export class Bewertung {
  constructor({
    id,
    beurteilung,
    sterne,
  }: {
    id: string;
    beurteilung: string;
    sterne: number;
  }) {
    this.id = id;
    this.beurteilung = beurteilung;
    this.sterne = sterne;
  }

  id: string;
  beurteilung: string;
  sterne: number;
}
